import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { LeveledEffectAction } from "../EffectActions/LeveledEffectAction.js";
import { Qualifier } from "../../../internal/qualifier/Qualifier.js";
import { QualifierValue } from "../../../internal/qualifier/QualifierValue.js";
import { prepareColor } from "../../../internal/utils/prepareColor.js";
import { ACTION_TYPE_TO_EFFECT_MODE_MAP } from "../../../internal/internalConstants.js";
/**
 * @description Makes the background of the image transparent (or solid white for formats that do not support transparency).
 * @extends LeveledEffectAction
 * @memberOf Actions.Effect
 * @see Visit {@link Actions.Effect|Effect} for an example
 */

var MakeTransparentEffectAction = /*#__PURE__*/function (_LeveledEffectAction) {
  _inherits(MakeTransparentEffectAction, _LeveledEffectAction);

  var _super = _createSuper(MakeTransparentEffectAction);

  function MakeTransparentEffectAction() {
    var _this;

    _classCallCheck(this, MakeTransparentEffectAction);

    _this = _super.apply(this, arguments);
    _this._actionModel = {
      actionType: 'makeTransparent'
    };
    return _this;
  }
  /**
   * @description Sets the tolerance used to accommodate variance in the background color.
   * @param {number | string} value The tolerance used to accommodate variance in the background color. (Range: 0 to 100, Server default: 10)
   */


  _createClass(MakeTransparentEffectAction, [{
    key: "tolerance",
    value: function tolerance(value) {
      this._actionModel.tolerance = value;
      var qualifierEffect = this.createEffectQualifier(this.effectType, value);
      this.addQualifier(qualifierEffect);
      return this;
    }
    /**
     * @description Sets the color to make transparent.
     * @param {string} color The HTML name of the color (red, green, etc.) or RGB hex code.
     * @return {this}
     */

  }, {
    key: "colorToReplace",
    value: function colorToReplace(color) {
      this._actionModel.color = color;
      return this.addQualifier(new Qualifier('co', new QualifierValue(prepareColor(color))));
    }
  }], [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var actionType = actionModel.actionType,
          tolerance = actionModel.tolerance,
          color = actionModel.color; // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [actionModel])
      // This allows the inheriting classes to determine the class to be created

      var result = new this(ACTION_TYPE_TO_EFFECT_MODE_MAP[actionType], tolerance);
      tolerance && result.tolerance(tolerance);
      color && result.colorToReplace(color);
      return result;
    }
  }]);

  return MakeTransparentEffectAction;
}(LeveledEffectAction);

export { MakeTransparentEffectAction };